import { RouteType } from "../../../types/RouteType";

const MoistureCorrectionWorkflowRoute: RouteType = {
  name: "Moisture Correction",
  path: "/workflows/moisture-correction",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./MoistureCorrectionWorkflowHeader"),
      title: "Apply Moisture Correction",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./MoistureCorrectionWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default MoistureCorrectionWorkflowRoute;
